<script lang="ts">
    import ContentItem from "@reperio-news/core.components/blocks/ContentItem/View.svelte";
    // @ts-ignore
    import loadingSVG from "./loading.svg";

    export let data: any = {};
    export let already_loaded_ids = [];

    let loader: HTMLDivElement;
    let used = false;
    let visible = false;
    let loading = false;

    let items: any[] = [];

    async function scroll(_e: Event) {
        if (used || loading) {
            return;
        }

        const rect = loader.getBoundingClientRect();

        visible =
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <=
                (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <=
                (window.innerWidth || document.documentElement.clientWidth);
    }

    async function load() {
        if (already_loaded_ids.length < data?.config?.limit) {
            used = true;
            return;
        }

        loading = true;

        const res = await fetch(
            `/content.json?query_json=${encodeURIComponent(
                JSON.stringify({
                    ...data.config,
                    offset: already_loaded_ids.length,
                })
            )}`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        const json = await res.json();

        if (json.items.length === 0) {
            used = true;
        }

        items = items.concat(
            json.items.filter(
                (item: any) => !already_loaded_ids.includes(item.id)
            )
        );

        already_loaded_ids = already_loaded_ids.concat(
            json.items.map((item: any) => item.id)
        );

        loading = false;
    }

    $: if (visible && !used) {
        load();
    }
</script>

{#if items && items.length}
    {#each items as item}
        <ContentItem
            type="ContentItem"
            data={{
                content: item,
                layout: data.content_layout,
                custom_fields: data.content_custom_fields,
            }}
        />
    {/each}
{/if}

{#if !used || loading}
    <div class="loader" bind:this={loader}>
        {#if loading}
            <img src={loadingSVG} alt="loading" width="75" height="75" />
        {/if}
    </div>
{/if}

<svelte:window on:scroll={scroll} />

<style lang="scss">
    .loader {
        width: calc(100% - 20px);
        height: 75px;
        text-align: center;
    }
</style>
